import type * as React from "react";
import { cn } from "../utils/mergeClassNames";

interface IBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

/**
 * Box component - A simple wrapper for a div element
 * @param props - Standard HTML div attributes
 */
const Box = ({ className, ...props }: IBoxProps) => {
  return (
    <div
      className={cn("block", className)}
      {...props}
    />
  );
};
Box.displayName = "Box";

export { Box };
